import Vue from 'vue';

export default {
  // 申请撤销
  applyRevocation(bidId) {
    return Vue.axios.get('api/v1.0/chanquan/bid/applyRevocation?bidId=' + bidId);
  }
};
